module.exports = __webpack_public_path__ + "static/media/T12_headboard Finishing_Fabric_White.f7c1edb6.png";